function serializeSpoilerScrapeResultForm(form, itemsJson) {
  var items = {};

  form.querySelectorAll('[data-spoiler-scrape-item-id][data-spoiler-scrape-field]').forEach(function(input) {
    var itemId = input.dataset.spoilerScrapeItemId;
    var field = input.dataset.spoilerScrapeField;
    items[itemId] = items[itemId] || { id: itemId, exclude_finishes: {} };

    if (field === 'exclude_finishes') {
      items[itemId].exclude_finishes[input.dataset.spoilerScrapeFinish] = input.checked;
    } else {
      items[itemId][field] = input.value;
    }
  });

  itemsJson.value = JSON.stringify(items);
  return items;
}

function initSpoilerScrapeResultForm(doc) {
  doc = doc || document;

  var form = doc.getElementById('spoiler-scrape-result-form');
  var itemsJson = doc.getElementById('spoiler-scrape-items-json');

  if (!form || !itemsJson || form.dataset.spoilerScrapeResultBound === 'true') {
    return;
  }

  form.dataset.spoilerScrapeResultBound = 'true';
  form.addEventListener('submit', function() {
    serializeSpoilerScrapeResultForm(form, itemsJson);
  });
}

export { initSpoilerScrapeResultForm, serializeSpoilerScrapeResultForm };

window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.initSpoilerScrapeResultForm = initSpoilerScrapeResultForm;
window.MTGGoldfish.serializeSpoilerScrapeResultForm = serializeSpoilerScrapeResultForm;
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {
  initSpoilerScrapeResultForm();
});
